import { BellRing, Volume2, VolumeX } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { useAuth } from '../context/AuthContext'

type IncomingOrder={id:string;display_number:number;created_at:string;created_by:string|null;status:string;dining_tables:{number:number;name:string|null}|null}
const storageKey='goncalo_cashier_loud_alarm'
let context:AudioContext|null=null

function alarmSound(){
 try{
  const AudioCtx=window.AudioContext||((window as typeof window&{webkitAudioContext?:typeof AudioContext}).webkitAudioContext)
  if(!AudioCtx)return false
  context??=new AudioCtx()
  const ctx=context
  void ctx.resume()
  const base=ctx.currentTime+.035
  for(let i=0;i<6;i++){
   const time=base+i*.36
   const osc=ctx.createOscillator()
   const gain=ctx.createGain()
   osc.type='square'
   osc.frequency.setValueAtTime(i%2===0?900:690,time)
   gain.gain.setValueAtTime(.0001,time)
   gain.gain.linearRampToValueAtTime(.24,time+.025)
   gain.gain.setValueAtTime(.24,time+.19)
   gain.gain.exponentialRampToValueAtTime(.0001,time+.29)
   osc.connect(gain);gain.connect(ctx.destination)
   osc.start(time);osc.stop(time+.3)
  }
  return true
 }catch{return false}
}

export function CashierOrderAlarm({orders,loading}:{orders:IncomingOrder[];loading:boolean}){
 const {user}=useAuth()
 const [enabled,setEnabled]=useState(()=>window.localStorage.getItem(storageKey)==='on')
 const [latest,setLatest]=useState<IncomingOrder|null>(null)
 const [pending,setPending]=useState(0)
 const initialized=useRef(false)
 const seen=useRef(new Set<string>())
 const audioEnabled=useRef(enabled)
 const account=useRef(user?.id)
 account.current=user?.id
 useEffect(()=>{audioEnabled.current=enabled},[enabled])
 useEffect(()=>{
  if(loading)return
  const currentIds=new Set(orders.map(order=>order.id))
  if(!initialized.current){
   initialized.current=true;seen.current=currentIds
   return
  }
  const newOrders=orders.filter(order=>!seen.current.has(order.id)
   &&order.created_by!==account.current
   &&!['draft','cancelled','closed'].includes(order.status)
   &&Date.now()-new Date(order.created_at).getTime()>=0
   &&Date.now()-new Date(order.created_at).getTime()<5*60*1000)
  seen.current=currentIds
  if(!newOrders.length)return
  const newest=[...newOrders].sort((a,b)=>Date.parse(b.created_at)-Date.parse(a.created_at))[0]
  setLatest(newest);setPending(previous=>previous+newOrders.length)
  if(audioEnabled.current)alarmSound()
 },[orders,loading])

 function turnOn(){
  const next=!enabled
  setEnabled(next);audioEnabled.current=next
  window.localStorage.setItem(storageKey,next?'on':'off')
  if(next)alarmSound()
 }
 function test(){alarmSound()}
 return <section className={latest?'cashier-alarm-bar cashier-alarm-new':'cashier-alarm-bar'} aria-label="Alerta de pedidos recebidos">
  <div className="cashier-alarm-info">
   <BellRing size={24}/>
   <div><strong>{latest?`NOVO PEDIDO · ${latest.dining_tables?.number!=null?'MESA '+latest.dining_tables.number:'BALCÃO / DELIVERY'} · #${latest.display_number}`:'Alerta alto de novos pedidos'}</strong>
    <small>{latest?`${pending} pedido(s) novo(s) desde sua última conferência.`:'Ative o som para ouvir quando chegar pedido de outro aparelho.'}</small>
   </div>
  </div>
  <div className="cashier-alarm-actions">
   {latest&&<button type="button" className="ghost-button" onClick={()=>{setLatest(null);setPending(0)}}>Conferido</button>}
   <button type="button" className="ghost-button" onClick={test}><Volume2 size={17}/> Testar</button>
   <button type="button" className={enabled?'secondary-button':'primary-button'} onClick={turnOn}>{enabled?<Volume2 size={17}/>:<VolumeX size={17}/>} {enabled?'Som alto ligado':'Ativar alerta alto'}</button>
  </div>
  <small className="cashier-alarm-hint">Deixe esta página aberta no Chrome e o volume do Windows ligado. O Chrome só libera áudio após interação.</small>
 </section>
}
